var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fetchAuthorizedJsonApi, fetchJsonApi } from './abstract';
import { EHeroLogType } from '../slices/discoveries/types';
import { getPlatform } from './platform';
import { getApiLanguage } from './language';
export function fetchDiscoveries(apiUrl, country, buildNumber) {
    return fetchJsonApi({
        apiUrl: apiUrl,
        body: undefined,
        skipHumanVerification: undefined,
        method: 'GET',
        endpoint: 'v2/hero/slides',
        query: {
            country: country,
            platform: getPlatform(),
            version: buildNumber !== null && buildNumber !== void 0 ? buildNumber : undefined,
            lang: getApiLanguage(),
            placement: 'hero',
        },
        expectedStatus: 200,
        description: 'Fetching hero discoveries',
    });
}
export function fetchJobSlides(apiUrl, country, buildNumber) {
    return fetchJsonApi({
        apiUrl: apiUrl,
        body: undefined,
        skipHumanVerification: undefined,
        method: 'GET',
        endpoint: 'v2/hero/slides',
        query: {
            country: country,
            platform: getPlatform(),
            version: buildNumber !== null && buildNumber !== void 0 ? buildNumber : undefined,
            lang: getApiLanguage(),
            placement: 'job-z',
        },
        expectedStatus: 200,
        description: 'Fetching Job Z slides',
    });
}
export function markDiscovery(apiUrl, token, discoveryId, logType) {
    if (logType === void 0) { logType = EHeroLogType.VIEW; }
    var logTypeQuery = {};
    if (logType === EHeroLogType.CLICKED) {
        logTypeQuery = { clicked: true };
    }
    else if (logType === EHeroLogType.DISMISSED) {
        logTypeQuery = { dismissed: true };
    }
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        token: token,
        method: 'POST',
        body: undefined,
        endpoint: "v1/hero/slides/".concat(discoveryId, "/log"),
        query: __assign(__assign({}, logTypeQuery), { platform: getPlatform() }),
        expectedStatus: 204,
        description: 'Marking discovery clicked',
    });
}
